import { render, staticRenderFns } from "./LogsView.vue?vue&type=template&id=22a77cbf&scoped=true"
import script from "./LogsView.ts?vue&type=script&lang=ts&external"
export * from "./LogsView.ts?vue&type=script&lang=ts&external"
import style0 from "./LogsView.scss?vue&type=style&index=0&id=22a77cbf&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a77cbf",
  null
  
)

export default component.exports